import request from '@/utils/request'

export function loginByUsername(query) {
  return request({
    url: '/admin/AdminLogin.action',
    method: 'post',
    params: query
  })
}


export function getUserInfo(query) {
  return request({
    url: '/admin/GetUserInfo.action',
    method: 'post',
    params: query
  })
}


export function updatePass(query) {
  return request({
    url: '/admin/UpdatePassword.action',
    method: 'post',
    params: query
  })
}


export function adminLoginOut(query) {
  return request({
    url: '/admin/AdminLoginOut.action',
    method: 'post',
    params: query
  })
}

//消息提醒
export function SelectNewOrderCount(query) {
  return request({
    url: '/admin/SelectNewOrderCount.action',
    method: 'post',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js